
import { Box, Breadcrumbs, Container, Grid, Link, Paper, Typography } from "@mui/material";

import { NavBar } from "./NavBar";

import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import { BreadcrumbsProps } from "../interfaces/ui/BreadcrumbsInterface";

interface Props {
    children?:          React.ReactNode;
    breadcrumbs?:       BreadcrumbsProps[],
    backgroundPaper?:   boolean;
}

export const Layout = ( { children, breadcrumbs, backgroundPaper = true } : Props ) => {

    return (

        <>        
            <NavBar />            

            <Container maxWidth='xl' sx={{ mt: 15, pb: 5 }}>

                <Grid container>

                    <Grid size={{ md: 12, xs: 12 }}>

                    {
                        breadcrumbs?.length !== 0
                        &&
                            <Breadcrumbs aria-label="breadcrumb" separator={ <ArrowForwardIosOutlinedIcon style={{ marginBottom: 2, fontSize: 16 }} /> }>
                            
                                <HomeOutlinedIcon style={{ fontSize: 24, marginTop: 3 }} />

                                {
                                    breadcrumbs?.map( ( { text, link }, index ) => (

                                        ( index === breadcrumbs.length - 1 )
                                        ?
                                            link
                                            ?
                                                <Link key={ index } href={ link } sx={{ textDecoration: 'none' }}>
                                                    <Typography variant="subtitle2" color="secondary" fontSize={20} fontWeight={'600'}>
                                                        { text }
                                                    </Typography>
                                                </Link>
                                            :
                                                <Typography key={ index } variant="subtitle2" color="secondary" fontSize={20} fontWeight={'600'}>
                                                    { text }
                                                </Typography>
                                        :

                                            link
                                            ?
                                                <Link key={ index } href={ link } sx={{ textDecoration: 'none' }}>
                                                    <Typography variant="subtitle2" color="secondary" fontSize={16}>
                                                        { text }
                                                    </Typography>
                                                </Link>
                                            :
                                                <Typography key={ index } variant="subtitle2" color="secondary" fontSize={16}>
                                                    { text }
                                                </Typography>                                       
                                    ))
                                }

                            </Breadcrumbs>
                    }

                    </Grid>

                </Grid>

                <Box component={ backgroundPaper ? Paper : 'div' } sx={{ mt: 2, p: backgroundPaper ? 3 : 0 }}>

                    { children }

                </Box>
               
            </Container>
        
        </>      
       
    )
}